import React, { useRef, useState } from "react";
import styles from "./BuyCourse.module.css";

import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { countriesArray } from "../../../components/List";

import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { SelectButton } from "primereact/selectbutton";
import { Button } from "primereact/button";
import { Stepper } from "primereact/stepper";
import { StepperPanel } from "primereact/stepperpanel";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { GetCompanies } from "../../../store/company-store/company-actions";
import { GetCharges } from "../../../store/charge-store/charge-actions";
import { userActions } from "../../../store/auth-store/auth-slice";

import CreditCardPayment from "../../../components/creditCardPayment/CreditCardPayment";
import TransferencePayment from "../../../components/transferencePayment/TransferencePayment";
import { getTokenInfo } from "../../../utils/Guard";
import {
  GetUserById,
  UpdateDetail,
} from "../../../store/auth-store/auth-actions";
import { GetCourse } from "../../../store/course-store/course-actions";
import { CreateOrder, UpdatePaymenMethod } from "../../../store/orden-store/orden-actions";
import { ordenActions } from "../../../store/orden-store/orden-slice";
import { uiActions } from "../../../store/ui-slice";
import Loading from "../../../components/loading/Loading";
import { InputMask } from "primereact/inputmask";

let callOnce = true;
let callOnce2 = true;

const BuyCourse = () => {
  const dispatch = useDispatch();
  const options = ["Tarjeta", "Transferencia"];
  const taxReceiptOptions = ["Si", "No"];
  const param = useParams();
  const userInfo = getTokenInfo();
  const stepperRef = useRef(null);
  const [value, setValue] = useState(null);
  const [taxReceiptValue, setTaxreceiptValue] = useState(null);

  const [selectedCountry, setSelectedCountry] = useState();
  const [selectedCharge, setSelectedCharge] = useState({ code: 0, name: "" });
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [countries, setCountries] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [charges, setCharges] = useState([]);

  const [invalidField, setInvalidField] = useState("");

  const company = useSelector((state) => state.company);
  const charge = useSelector((state) => state.charge);
  const country = countriesArray;
  const user = useSelector((state) => state.auth.auth);
  const course = useSelector((state) => state.course.course);
  const order = useSelector((state) => state.orden.orden);
  const [discountCode, setDiscountCode] = useState();
  const notification = useSelector((state) => state.ui.notification);





  useEffect(() => {
    if (
      (userInfo !== undefined &&
        userInfo !== null &&
        userInfo.UserId !== undefined &&
        userInfo.UserId !== null &&
        user.name === "") ||
      user.length === 0
    ) {
      dispatch(GetUserById(userInfo.UserId, userInfo.Email, null, false));
    }
  }, [userInfo, dispatch]);

  useEffect(() => {
    if (company.companies === undefined || company.companies.length === 0) {
      dispatch(GetCompanies("capacitaciones@aba.org.do"));
    }
  }, []);

  useEffect(() => {
    if (charge.charges === undefined || charge.charges.length === 0) {
      dispatch(GetCharges("capacitaciones@aba.org.do", true));
    }
  });

  useEffect(() => {
    if (country !== undefined && country.length > 0) {
      var id = 0;
      const listCountries = country.map((country) => {
        id++;
        return {
          code: country.name,
          name: country.name,
          flag: country.abreviatura,
        };
      });
      setCountries(listCountries);
    }
  }, [country]);

  useEffect(() => {
    if (notification !== null && notification !== undefined && notification.message === "Curso no encontrado.") {
      window.location.href = "/courses/none";
    }
  }, [notification]);

  useEffect(() => {
    if (charge.charges !== undefined && charge.charges.length > 0) {
      const listCharges = charge.charges.map((charge) => {
        return {
          code: charge.id,
          name: charge.name,
        };
      });
      setCharges(listCharges);
    }
  }, [charge.charges]);

  useEffect(() => {
    if (
      course === undefined ||
      course === null ||
      course.id === null ||
      course.id === undefined ||
      course.id === 0
    ) {
      if (
        userInfo !== undefined &&
        userInfo !== null &&
        userInfo.UserId !== null &&
        userInfo.UserId !== undefined &&
        param.courseid !== undefined &&
        callOnce
      ) {
        callOnce = false;

        dispatch(
          GetCourse(param.courseid, userInfo.UserId, "aulaaba.aba.org.do")
        );
      } else {
        if (callOnce) {
          callOnce = false;
          dispatch(GetCourse(param.courseid, 0, "aulaaba.aba.org.do"));
        }
      }
    }
  }, [course, dispatch, param.courseid, userInfo]);

  const selectedCountryTemplate = (option, props) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <img
            alt={option.name}
            src={`https://flagcdn.com/48x36/${option.flag.toLowerCase()}.png`}
            style={{ width: "18px" }}
          />
          <div style={{ marginLeft: "5%" }}>{option.name}</div>
        </div>
      );
    }

    return <span>{props.placeholder}</span>;
  };

  const onChangeCountriesHandler = (id, value) => {
    dispatch(userActions.modifyPropertyValue({ id, value: value.code }));
    setSelectedCountry({
      code: value.code,
      name: value.name,
      flag: value.flag,
    });
  };

  const proceedToPayment = async () => {
    if (value !== "Tarjeta" && value !== "Transferencia") {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error",
          message: "Debe indicar el método de pago",
        })
      );
      return;
    }

  //Validations

    setInvalidField("");

    if (user.name === "") {
      dispatch(
        uiActions.showNotification({
          message: "El nombre es requerido",
          status: "warning",
        })
      );
      setInvalidField("name");
      return;
    } else if (user.email === "") {
      dispatch(
        uiActions.showNotification({
          message: "El email es requerido",
          status: "warning",
        })
      );
      setInvalidField("email");
      return;
    } else if (user.lastName === "") {
      dispatch(
        uiActions.showNotification({
          message: "El apellido es requerido",
          status: "warning",
        })
      );
      setInvalidField("lastName");
      return;
    }
    else if (user.cellPhone === "") {
      dispatch(
        uiActions.showNotification({
          message: "El teléfono es requerido",
          status: "warning",
        })
      );
      setInvalidField("cellPhone");
      return;
    }
    else if (user.city === "") {
      dispatch(
        uiActions.showNotification({
          message: "La ciudad es requerida",
          status: "warning",
        })
      );
      setInvalidField("city");
      return;
    }
    else if (user.address === "") {
      dispatch(
        uiActions.showNotification({
          message: "La dirección es requerida",
          status: "warning",
        })
      );
      setInvalidField("address");
      return;
    }
    else if (!selectedCountry) {
      dispatch(
        uiActions.showNotification({
          message: "El país es requerido",
          status: "warning",
        })
      );
      setInvalidField("country");
      return;
    }
    else if (!selectedCompany) {
      dispatch(
        uiActions.showNotification({
          message: "La empresa es requerida",
          status: "warning",
        })
      );
      setInvalidField("company");
      return;
    }
    else if (!selectedCharge.code) {
      dispatch(
        uiActions.showNotification({
          message: "El cargo es requerido",
          status: "warning",
        })
      );
      setInvalidField("charge");
      return;
    } else if (taxReceiptValue !== "Si" && taxReceiptValue !== "No") {
      dispatch(
        uiActions.showNotification({
          message: "Debe indicar si desea comprobante fiscal",
          status: "warning",
        })
      );
      return;
    }
    else if (taxReceiptValue === "Si" && order.rnc === "") {
      dispatch(
        uiActions.showNotification({
          message: "El RNC es requerido",
          status: "warning",
        })
      );
      setInvalidField("rnc");
      return;
    }

    var compa = {};
    if (
      selectedCompany !== null &&
      selectedCompany !== undefined &&
      selectedCompany.code !== undefined
    ) {
      compa = { ...selectedCompany };
    } else {
      compa = {
        code: 0,
        name: selectedCompany,
      };
    }

    const newUser = {
      ...user,
      charge: {
        id: selectedCharge.code,
        name: selectedCharge.name,
      },
      country: selectedCountry.name,
      company: compa,
    };

    await dispatch(UpdateDetail(userInfo.Email, newUser));

    dispatch(
      ordenActions.setOrden({
        orden: {},
      })
    );

    if (userInfo !== null && userInfo !== undefined) {
      userInfo.OrdenId = 0;
    }

    const orden = {
      userName: user.email,
      courseId: course.id,
      discountCode: discountCode,
      amount: course.price,
      quantityOfUsers: 1,
      rnc: order.rnc,
      taxBill: taxReceiptValue === "Si" ? true : false,
    };

    await dispatch(CreateOrder(orden, orden.userName));

    stepperRef.current.nextCallback();
  };

  const onChangeCompaniesHandler = (id, value) => {
    if (value.name !== undefined && value.name !== "" && value.name !== null) {
      dispatch(
        userActions.modifyPropertyValue({
          id,
          value: {
            id: value.code,
            name: value.name,
          },
        })
      );
      setSelectedCompany(value.name);
    } else {
      dispatch(
        userActions.modifyPropertyValue({
          id,
          value: {
            id: 0,
            name: value,
          },
        })
      );
      setSelectedCompany(value);
    }
  };

  useEffect(() => {
    if (company.companies !== undefined && company.companies.length > 0) {
      const listCompanies = company.companies.map((company) => {
        return {
          code: company.id,
          name: company.name,
          rnc: company.rnc,
        };
      });
      setCompanies(listCompanies);
    }
  }, [company.companies]);

  const countryOptionTemplate = (option) => {
    return (
      <div className="flex align-items-center" style={{ width: "100px" }}>
        <img
          alt={option.name}
          src={`https://flagcdn.com/48x36/${option.flag.toLowerCase()}.png`}
          style={{ width: "18px" }}
        />
        <div style={{ marginLeft: "5%" }}>{option.name}</div>
      </div>
    );
  };

  useEffect(() => {
    if (
      userInfo !== null &&
      userInfo !== undefined &&
      userInfo.UserId !== undefined &&
      userInfo.UserId !== null
    ) {
      if (selectedCountry === undefined || selectedCountry === null) {
        const foundCountry = country.find(
          (country) => country.name === user.country
        );

        if (foundCountry !== undefined && foundCountry !== null) {
          const countryWithCode = {
            ...foundCountry,
            code: foundCountry.name,
            flag: foundCountry.abreviatura,
          };
          delete countryWithCode.abreviatura;
          onChangeCountriesHandler("countryid", countryWithCode);
        }
      }

      if (
        selectedCharge.code === 0 &&
        user.charge.id !== 0 &&
        user.charge.id !== null &&
        user.charge.id !== undefined
      ) {
        const chargeWithCode = {
          ...user.charge,
          code: user.charge.id,
        };
        delete chargeWithCode.id;
        onChangeChargesHandler("charge", chargeWithCode);
      }
      if (
        selectedCompany === undefined || selectedCompany === null &&
        user.company.id !== 0 &&
        user.company.id !== null &&
        user.company.id !== undefined
      ) {
        onChangeCompaniesHandler("company", user.company.name);
      }
    }
  }, [userInfo]);

  const onChangeChargesHandler = (id, value) => {
    dispatch(userActions.modifyPropertyValue({ id, value: value.code }));
    setSelectedCharge({
      code: value.code,
      name: value.name,
    });
  };

  const onChangeOrdenHandler = (id, value) => {


    if (id === "rnc") {
      dispatch(ordenActions.modifyPropertyValue({ id, value }));
    }
  }


  const onChangeHandler = (id, value) => {
    if (id !== "charge" && id !== "department") {
      dispatch(userActions.modifyPropertyValue({ id, value }));
      if (value !== "") {
        dispatch(userActions.setFieldValid({ id, value: true }));
      } else {
        dispatch(userActions.setFieldValid({ id, value: false }));
      }
    } else {
      dispatch(userActions.modifyPropertyValue({ id, value: { id: value } }));
    }
  };

  return (
    <div className={styles.buyCourse}>
      <Stepper ref={stepperRef}>
        <StepperPanel header="facturación">
          {user.name !== undefined && user.name !== null && user.name !== "" ? (
            <>
              <h1 className={styles.formTitle}>Facturación</h1>
              <div className={styles.facturationForm}>
                <div className={styles.forms}>
                  <div className={styles.column}>
                    <label htmlFor="nombre">Nombre</label>
                    <InputText
                      onChange={(e) => onChangeHandler("name", e.target.value)}
                      defaultValue={user.name}
                      value={user.name}
                      type="text"
                      id="name"
                      disabled
                    />
                  </div>
                  <div className={styles.column}>
                    <label htmlFor="apellido">Apellido</label>
                    <InputText
                      defaultValue={
                        userInfo !== null &&
                          userInfo !== undefined &&
                          userInfo.LastName !== undefined &&
                          userInfo.LastName !== null
                          ? userInfo.LastName
                          : ""
                      }
                      onChange={(e) => onChangeHandler("lastName", e.target.value)}
                      value={user.LastName}
                      type="text"
                      id="lastName"
                      disabled
                    />
                  </div>
                  <div className={styles.column}>
                    <label htmlFor="correo">Correo</label>
                    <InputText
                      defaultValue={
                        userInfo !== null &&
                          userInfo !== undefined &&
                          userInfo.Email !== undefined &&
                          userInfo.Email !== null
                          ? userInfo.Email
                          : ""
                      }
                      value={user.Email}
                      onChange={(e) => onChangeHandler("email", e.target.value)}
                      type="text"
                      id="email"
                      disabled
                    />
                  </div>
                  <div className={styles.column}>
                    <label htmlFor="telefono">Teléfono</label>
                    <InputMask
                      id="cellPhone"
                      value={user.cellPhone}
                      onChange={(e) => onChangeHandler("cellPhone", e.target.value)}
                      mask="+1999-999-9999"
                      placeholder="+1999-999-9999"
                      invalid={invalidField === "cellPhone"}
                    />
                  </div>
                  <div className={styles.column}>
                    <label htmlFor="pais">País</label>
                    <Dropdown
                      value={selectedCountry}
                      onChange={(e) => {
                        onChangeCountriesHandler("countryid", e.value);
                      }}
                      options={countries}
                      optionLabel="name"
                      placeholder="Seleccionar pais"
                      valueTemplate={selectedCountryTemplate}
                      filter
                      itemTemplate={countryOptionTemplate}
                      className={styles.profileDropdown}
                      invalid={invalidField === "country"}
                    />
                  </div>
                  <div className={styles.column}>
                    <label htmlFor="ciudad">Ciudad</label>
                    <InputText
                      onChange={(e) => onChangeHandler("city", e.target.value)}
                      defaultValue={user.city}
                      value={user.city}
                      type="text"
                      id="city"
                      invalid={invalidField === "city"}
                    />
                  </div>
                  <div className={styles.column}>
                    <label htmlFor="direccion">Dirección</label>
                    <InputText
                      defaultValue={user.address}
                      value={user.address}
                      onChange={(e) => onChangeHandler("address", e.target.value)}
                      type="text"
                      id="address"
                      invalid={invalidField === "address"}
                    />
                  </div>
                  <div className={styles.column}>
                    <label htmlFor="empresa">Empresa</label>
                    <Dropdown
                      className={styles.companyInput}
                      onChange={(e) => onChangeCompaniesHandler("company", e.value)}
                      options={companies}
                      optionLabel="name"
                      editable
                      placeholder="Seleccionar empresa"
                      value={selectedCompany}
                      // type="text"
                      id="company"
                      invalid={invalidField === "company"}
                    />
                  </div>
                  <div className={styles.column}>
                    <label htmlFor="cargo">Cargo</label>
                    <Dropdown
                      onChange={(e) => onChangeChargesHandler("charge", e.value)}
                      value={selectedCharge}
                      options={charges}
                      optionLabel="name"
                      className={styles.profileDropdown}
                      defaultValue={
                        userInfo !== null &&
                          userInfo !== undefined &&
                          userInfo.Charge !== undefined &&
                          userInfo.Charge !== null
                          ? userInfo.Charge
                          : ""
                      }
                      placeholder="Seleccionar cargo"
                      filter
                      // type="text"
                      id="charge"
                      invalid={invalidField === "charge"}
                    />
                  </div>

                  <div className={styles.column}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: "1.5%",
                        alignItems: "center",
                        width: "100%",
                        height: "100%",
                      }}
                    >
                      <div
                        style={{
                          alignSelf: "center",
                          flex: 1,
                          alignContent: "center",
                          textAlign: "center",
                        }}
                      >
                        <label htmlFor="empresa">
                          ¿Desea comprobante fiscal?
                        </label>
                        <SelectButton
                          title="¿Desea comprobante fiscal?"
                          className={styles.selectButton}
                          value={taxReceiptValue}
                          onChange={(e) => setTaxreceiptValue(e.value)}
                          options={taxReceiptOptions}
                          allowEmpty={false}
                        />
                      </div>
                      {taxReceiptValue === "Si" && (
                        <div
                          style={{
                            alignSelf: "center",
                            flex: 1,
                            alignItems: "center",
                          }}
                        >
                          <label htmlFor="rnc">RNC</label>
                          <InputText
                            onChange={(e) =>
                              onChangeOrdenHandler("rnc", e.target.value)
                            }
                            value={order.rnc}
                            type="text"
                            id="rnc"
                            className={styles.columnInput}
                            invalid={invalidField === "rnc"}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <div className={styles.column}>
                    <div
                      style={{
                        alignSelf: "center",
                        flex: 1,
                        alignContent: "center",
                        textAlign: "center",
                      }}
                    >
                      <label htmlFor="selectButton">Método de pago</label>
                      <SelectButton
                        title="Método de pago"
                        className={styles.selectButton}
                        value={value}
                        onChange={(e) => setValue(e.value)}
                        options={options}
                        allowEmpty={false}
                      />
                    </div>
                  </div>
                  <div className={styles.column}>
                    <label htmlFor="discountCode">Código de descuento</label>
                    <InputText
                      onChange={(e) => setDiscountCode(e.target.value)}
                      type="text"
                      id="discountCode"
                    />
                  </div>
                  <div className={styles.column}>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: "1.5%",
                        width: "100%",
                      }}
                    >
                      <Button
                        className={styles.saveButton}
                        label="Continuar"
                        onClick={() => proceedToPayment()}
                      />

                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : <Loading />}
        </StepperPanel>
        <StepperPanel header="pago">
          {value === "Tarjeta" ? (
            <CreditCardPayment stepperRef={stepperRef} />
          ) : value === "Transferencia" ? (
            <TransferencePayment stepperRef={stepperRef} />
          ) : value === null ? null : null}
        </StepperPanel>
      </Stepper>
    </div>
  );
};

export default BuyCourse;
